import app from "./app";

app.mount();

console.log("Hello World!");
